module.exports = {
	"gtm": {
		"title": "via Google Tag Manager",
		"installation": [
			{
				"text": "In order for Data-Driven to work properly with GTM, Data-Driven needs to be able to gather the necessary information from GTM. GTM in turn, gathers this information from the data layer on your website. Therefore make sure you have your data layer and variables setup correctly. This will ensure Data-Driven receives all the information it needs and you get all the benefits Data-Driven provides."
			},
			{
				"text": "You can find more detailed information about DataLayer and Variables under Google Tag Manager section <a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https: //help.divvit.com/installing-the-divvit-tracking\">here</a>"
			},
			{
				"text": "For tracking all page views and orders we need to install two custom pixels into GTM. The first one will be fired on all pages and tracks pageviews for Data-Driven. The second one will be fired only on the \"thankyou\" page after an order has been placed successfully and track orders for Data-Driven."
			},
			{
				"title": "General Tracking Pixel"
			},
			{
				"step": 1,
				"text": "Log in to your GTM account, click on \"Tags\" in the left sidebar navigation and click the \"New\" button on top of the page. You should reach a screen like this:"
			},
			{
				"image": "https://docs.divvit.com/assets/03e8eec5.jpg"
			},
			{
				"step": 2,
				"text": "Name the tag as Data-Driven General."
			},
			{
				"step": 3,
				"text": "Click on \"Custom HTML Tag\" and copy/paste the following code into the text field, replacing the YOUR_FRONTEND_ID with your Frontend ID from Data-Driven."
			},
			{
				"snippet": "pageview"
			},
			{
				"step": 4,
				"text": "Under the section \"Triggering\" make sure to select \"All pages\", so that the tracking code is invoked on all pages."
			},
			{
				"step": 5,
				"text": "Click \"Save\" button."
			},
			{
				"title": "Order Tracking Pixel"
			},
			{
				"step": 1,
				"text": "For Order Tracking Pixel you will use trigger called \"Complete page\". It is not built in GTM by default. Thus, you have to create it manually, as shown below:"
			},
			{
				"list": [
					"Log on to your Google Tag Manager account and click on Triggers on the left side menu",
					"Click new, and name your trigger \"Complete page\"",
					"Click on the icon in the middle and choose Page View as Trigger type.",
					"Now you have two checkboxes, one saying All Page Views and the other one Some Page Views, choose Some Page Views.",
					"Choose type as Page URL, leave contains as it is",
					"In the blank field, you have to enter a part of page URL without product information, for example /purchase/complete, hit save in the top left corner!",
					"To check you complete page url you have to make a test purchase on you site and copy exact URL you see on \"Thank you\" page after order is complete.",
					"Click \"Save\" button"
				]
			},
			{
				"step": 2,
				"text": "Go back to \"Tags\" by clicking in the left sidebar and select \"New\" to create another pixel. Choose the same settings as above (\"Custom HTML Tag\") and place the following code into the text field:"
			},
			{
				"snippet": "gtmOrder"
			},
			{
				"step": 3,
				"text": "Delete all lines which include a variable name that you have not set up in GTM, as described below:"
			},
			{
				"list": [
					[
						{
							"text": "If you don’t have transactionShipping remove the whole line that says:"
						},
						{
							"snippet": "transactionShipping"
						}
					],
					[
						{
							"text": "If you don’t have transactionCurrency remove the whole line that says:"
						},
						{
							"snippet": "transactionCurrency"
						}
					],
					[
						{
							"text": "If you don’t have transactionPaymentMethod remove the whole line that says:"
						},
						{
							"snippet": "transactionPaymentMethod"
						}
					],
					[
						{
							"text": "If you don’t have transactionDiscount remove the whole line that says:"
						},
						{
							"snippet": "transactionDiscount"
						}
					],
					[
						{
							"text": "If you don’t have transactionDiscountCode remove the whole line that says:"
						},
						{
							"snippet": "transactionDiscountCode"
						}
					],
					[
						{
							"text": "If you don’t have transactionCustomerID remove the whole line that says:"
						},
						{
							"snippet": "transactionCustomerID"
						}
					],
					[
						{
							"text": "If you don’t have transactionProducts remove the whole line that says:"
						},
						{
							"snippet": "transactionProducts"
						},
						{
							"text": "Also that block:"
						},
						{
							"snippet": "transactionProductsBlock"
						}
					]
				]
			},
			{
				"step": 4,
				"text": "To make sure that this pixel is fired after the general tracking pixel, in the section of Advanced settings underneath the text field please press Tag Sequencing Button and activate the checkbox \"Fire a tag before Data-Driven Order Tracking fires\". Select the first general Data-Driven tracking pixel from the select list."
			},
			{
				"step": 5,
				"text": "Under the section \"Triggering\" select \"Complete page\"."
			},
			{
				"step": 6,
				"text": "Click \"Save\" button."
			},
			{
				"text": "Before you publish the Data-Driven scripts in Google Tag Manager, it might be a good idea to preview it and make sure it's working. To do that, click the top right button that says \"Preview\". If you get an error message go back to GTM section where error occurs and make sure everything is fixed."
			}
		]
	},
	"other": {
		"title": "Data-Driven Custom Integration",
		"installation": [
			{
				"title": "Include the following DIVVIT Javascript snippet on each page",
				"subtitle": "Required: Install the main tracking script",
				"step": 1,
				"text": "Insert the following code right underneath the opening &lt;body&gt; tag:"
			},
			{
				"snippet": "pageview"
			},
			{
				"subtitle": "Optional: Transmit additional visitor information",
				"step": 2,
				"text": "In case the visitor is logged into his or her account, you can transmit this information in a separate function call to Data-Driven to enhance cross-device tracking abilities."
			},
			{
				"snippet": "customer"
			},
			{
				"step": 1,
				"title": "Include individual Javascript calls on different page types",
				"subtitle": "Required: Send information about placed orders",
				"text": "The following code should be placed on the page which the customer reaches after an order has been placed successfully (\"thank you\" page, or checkout success page)."
			},
			{
				"snippet": "order"
			},
			{
				"step": 2,
				"subtitle": "Optional: Update products in cart",
				"text": "To track products that have been added to the cart, you can either go for an event-based approach or update the total cart each time the user adds or removes a product."
			},
			{
				"snippet": "cart"
			},
			{
				"step": 3,
				"text": "If everything is configured correctly you should see the the Data-Driven tracking pixel on your site."
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./client/components/Wizard/instructions.json
// module id = 926
// module chunks = 0